import api from '#config/api';

export const createPeriod = values => api.post('/periods', values);

export const getAllPeriods = () => api.get('/periods');
